import React from 'react';
import classNames from 'classnames';
import { IParticipant } from 'twain-sport-fe-mono/interfaces';
import classes from './ParticipantCard.module.scss';

interface IProps {
    participantCode?: IParticipant['code'];
    oneLineNickname?: boolean;
    withAvatar?: boolean;
    className?: string;
    reverse?: boolean;
    onClick?(code: string): void;
}

export const ParticipantCard: React.FC<React.PropsWithChildren<IProps>> = (props) => {
    const onClick = () => {
        if (!props.onClick || !props.participantCode) {
            return;
        }

        props.onClick(props.participantCode);
    };

    return (
        <div
            className={classNames(classes.container, props.className, {
                [classes.withAvatar]: props.withAvatar,
                [classes.oneLineNickname]: props.oneLineNickname,
                [classes.withLink]: props.onClick && props.participantCode,
                [classes.reverse]: props.reverse,
            })}
            role="presentation"
            onClick={onClick}
        >
            {props.children}
        </div>
    );
};
